import type { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useAppState } from 'state';

import ErrorComponent from 'app/ui/components/molecules/error';
import { WorkoutPageWrapper } from 'app/pages/workout';
import { WorkoutDataProvider } from 'app/pages/workout/context';
import styled, { ThemeProvider } from 'styled-components';
import { theme } from 'src/app/providers/theme';

const invertedTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    black: theme.colors.white,
    white: theme.colors.black,
    focoltone: theme.colors.veryGray,
    lightGray: theme.colors.black,
    paragraphGray: theme.colors.black,
    veryGray: theme.colors.white,
  },
};

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  height: 100vh;
  width: 100%;
  overflow-y: auto;
  
  svg {
    fill: ${({ theme }) => theme.colors.black};
  }
`;

const WorkoutPdf: FC = () => {
  const { id: lessonId } = useParams();
  const userId = useAppState(({ auth }) => auth.userId);

  if (!lessonId || !userId) {
    return <ErrorComponent />;
  }

  return (
    <Container>
      <ThemeProvider theme={invertedTheme}>
        <WorkoutDataProvider>
          <WorkoutPageWrapper lessonId={lessonId} userId={userId} variant="pdf" />
        </WorkoutDataProvider>
      </ThemeProvider>
    </Container>
  );
};

export default WorkoutPdf;
